import React from 'react';

const MissionVision = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        
        <h2 className="text-3xl md:text-3xl font-bold text-center mb-12 text-[#741112]">
          Our Belief System
        </h2>
 
        {/* 4-column grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">

          {/* Mission Image */}
          <div>
            <img
              src="assets/mission.png"
              alt="Mission"
              className="w-full h-80 object-cover rounded-lg shadow-lg"
            />
          </div>

          {/* Mission Text */}
          <div className="bg-gray-50 rounded-lg p-6 shadow hover:shadow-lg transition duration-300 flex flex-col justify-center">
            <h3 className="text-xl md:text-2xl font-semibold mb-3 text-[#741112]">
              Mission
            </h3>
            <p className="text-gray-700 text-sm md:text-base">
              Create transparency at each level function of
work and innovate new techniques and
strategies to accelerate businesses.
            </p>
          </div>

          {/* Vision Image */}
          <div>
            <img
              src="assets/vission.webp"
              alt="Vision"
              className="w-full h-80 object-cover rounded-lg shadow-lg"
            />
          </div>

          {/* Vision Text */}
          <div className="bg-gray-50 rounded-lg p-6 shadow hover:shadow-lg transition duration-300 flex flex-col justify-center">
            <h3 className="text-xl md:text-2xl font-semibold mb-3 text-[#741112]">
              Vision
            </h3>
            <p className="text-gray-700 text-sm md:text-base">
To become a real estate marketing and sales
company on which developer partners,
Sales Partners could rely on completely.            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default MissionVision;
